import React, { memo } from "react";

import SkeletonPlaceholder from "@/components/molecules/SkeletonPlaceholder";

import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";

/**
 * Props for SkeletonShadowTeamView component
 */
interface Props {
  bgColor: string;
}

/**
 * Pure view component for shadow team skeleton
 * @param root0 - Component props
 * @param root0.bgColor - Background color value
 */
const SkeletonShadowTeamView = ({ bgColor }: Props) => (
  <SkeletonPlaceholder>
    <Stack direction="horizontal" className="min-h-20 items-center gap-4 py-2">
      <Box
        className={`h-8 w-full animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
      <Box
        className={`h-7 w-14 animate-pulse rounded-none opacity-70 ${bgColor}`}
      />
    </Stack>
  </SkeletonPlaceholder>
);

SkeletonShadowTeamView.displayName = "SkeletonShadowTeamView";

export default memo(SkeletonShadowTeamView);
